<div class="flex flex-col h-full w-full box items-center justify-center">
  <div class="flex flex-col -mt-12">
    <div>
      <img src="../../../../assets/images/csimg.svg" alt="Email" />
    </div>
    <div class="text-white w-full text-center">
      <h2>Luminous Power Technologies</h2>
    </div>
  </div>

  <div
    class="flex lg:flex-row sm:flex-col text-dark-content mt-[4%] lg:w-full mainflex justify-around w-[90%] sm:w-fit"
  >
    <div class="grid grid-flow-col info h-[30%] gap-8 place-items-center">
      <div>
        <img
          class="imgs"
          src="../../../../assets/images/locatioon.svg"
          alt="Map"
        />
      </div>
      <div class="grid grid-flow-row lg:gap-[13.61px] sm:gap-3 text-s">
        <div><span class="text-sm font-medium">Address</span></div>
        <div class="text-wrap">
          <span>Plot No. 150, Sector 44, Gurgaon,Haryana-122003</span>
        </div>
        <div><hr class="w-80 h-0" /></div>
      </div>
    </div>
    <div
      class="grid grid-flow-col place-items-center gap-8 info h-[30%] sm:mt-10 lg:mt-0"
    >
      <div>
        <img
          class="imgs sm:h-full lg:h-unset"
          src="../../../../assets/images/phonnnn.svg"
          alt="Phone"
        />
      </div>
      <div class="grid grid-flow-row lg:gap-[13.61px] sm:gap-3 text-s">
        <div>
          <span class="text-sm font-medium">Sales Support</span>
        </div>
        <div class="text-wrap"><span>+91-9999933039</span></div>

        <div><hr class="w-80 h-0" /></div>
      </div>
    </div>
    <div
      class="grid grid-flow-col info place-items-center gap-8 sm:mt-10 lg:mt-0 h-[30%]"
    >
      <div>
        <img
          class="imgs"
          src="../../../../assets/images/messsage.svg"
          alt="Message"
        />
      </div>
      <div class="grid-flow-row grid lg:gap-[13.61px] sm:gap-3">
        <div><span class="font-semibold">E-mail</span></div>
        <div class="cursor-pointer text-wrap">
          <span
            [innerHTML]="'care&#64;luminousindia.com'"
            (appClickableDirective)="sendEmail()"
          ></span>
        </div>
        <div><hr class="w-80 h-0" /></div>
      </div>
    </div>
  </div>
</div>
